import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { DemoBadge } from 'pages/Operations/Shared/OpsSharedComponents'
import { Flex } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'
import { formatNumbersForDisplay } from 'utils/helpers'
import { IFuelSupplierClaim } from 'types/fuelOps.interface'
import { IStatusPill } from 'types/ui/statusPill.interface'
import { formatGhs, FUEL_CLAIMS_CAPTION, FUEL_DEMO_SUPPLIER_CLAIMS } from '../fuelOpsDemoData'
import { ClaimCellEm, ClaimCellText, ClaimNoteText, ClaimShortText } from './SupplierClaimsPanel.styled'

const claimTone = (status: IFuelSupplierClaim['status']): IStatusPill['status'] =>
    status === 'OPEN' ? 'warning' : status === 'SETTLED' ? 'success' : 'neutral'

const columns: IHonestTableColumn<IFuelSupplierClaim>[] = [
    { id: 'raised', header: 'RAISED', cell: (item) => <ClaimCellText>{item.raisedLabel}</ClaimCellText> },
    { id: 'supplier', header: 'SUPPLIER', cell: (item) => <ClaimCellEm>{item.supplier}</ClaimCellEm> },
    { id: 'delivery', header: 'DELIVERY', cell: (item) => <ClaimCellText>{item.deliveryRef}</ClaimCellText> },
    {
        id: 'shortLitres',
        header: 'SHORT LITRES',
        align: 'right',
        cell: (item) => (
            <ClaimShortText $open={item.status === 'OPEN'}>
                {`−${formatNumbersForDisplay(Math.abs(item.litresShort))} L`}
            </ClaimShortText>
        ),
    },
    {
        id: 'value',
        header: 'VALUE',
        align: 'right',
        cell: (item) => <ClaimShortText $open={item.status === 'OPEN'}>{formatGhs(item.valueGhs)}</ClaimShortText>,
    },
    { id: 'age', header: 'AGE', align: 'right', cell: (item) => <ClaimCellText>{`${item.ageDays}d`}</ClaimCellText> },
    {
        id: 'status',
        header: 'STATUS',
        cell: (item) => <StatusPill status={claimTone(item.status)}>{item.status}</StatusPill>,
    },
    {
        id: 'note',
        header: 'NOTE',
        minWidth: '16rem',
        cell: (item) => <ClaimNoteText>{item.note}</ClaimNoteText>,
    },
]

export const SupplierClaimsPanel = () => {
    const rows: IFuelSupplierClaim[] = FUEL_DEMO_SUPPLIER_CLAIMS
    return (
        <Container>
            <ContainerHeader>
                <Flex center gap='0.75rem'>
                    <TitleText>Delivery claims</TitleText>
                    {rows.length > 0 && <DemoBadge />}
                </Flex>
            </ContainerHeader>
            <ContainerContent gap='0.75rem'>
                <OtherText grey>{FUEL_CLAIMS_CAPTION}</OtherText>
                <HonestTable
                    columns={columns}
                    data={rows}
                    keyField='id'
                    emptyMessage='No delivery claims yet — short deliveries raised at receiving land here.'
                />
            </ContainerContent>
        </Container>
    )
}
